import { getJourneyType, setSessionVariablesToCookies } from "@utils/index";
import { decryptNextNodePiiResponse } from "@utils/nextNodePiiDecryption";
import axios from "axios";

export let headers: any = {
  "Content-Type": "application/json",
  Accept: "application/json",
  "Accept-Language": "en-US",
  "Cache-Control": "no-cache",
  "x-journey-version": "v3"
};

export const serverlog = (log: any) => {
  return fetch("/api/falcon/log", {
    method: "POST",
    body: JSON.stringify({ log }),
    headers: {
      "Content-Type": "application/json"
    }
  });
};
const fetchConfig = (payload: any) => {
  // const url = "http://localhost:3001/sdui/api/v1/next-node";
  // const url = "http://10.210.38.77:3000/sdui/api/v1/next-node";
  const url = `${process.env.SDUI_API_SERVICE}/next-node`;
  // const url = "https://auto-buy-sdui-service-uat.internal.ackodev.com/sdui/api/v1/next-node";
  if( getJourneyType() === "renewal_car" || getJourneyType() === "renewal_bike") {
    payload.data["session_data"]= setSessionVariablesToCookies();
  }
  return new Promise((resolve, reject) => {
    axios
      .post(url, payload, { headers: headers, withCredentials: true })
      .then(async (response) => {
        resolve(await decryptNextNodePiiResponse(response.data));
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sendOTPApi = (payload: any) => {
  const { token, ...restPayload } = payload;
  const url = `${process.env.SDUI_API_SERVICE}/send-otp`;
  // const url = "http://localhost:3001/sdui/api/v1/send-otp";
  // const url = "http://10.210.39.223:3000/sdui/api/v1/next-node"
  // const url = "https://auto-buy-sdui-service-uat.internal.ackodev.com/sdui/api/v1/next-node";
  const apiPayload = {
    journey: "fresh_car",
    data: {
      is_new: "false",
      origin: "acko",
      product: "car",
      ...restPayload
    }
  };

  headers = {
    "x-captcha-token": token,
    ...headers
  };

  return new Promise((resolve, reject) => {
    axios
      .post(url, apiPayload, { withCredentials: true, headers: headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sendOtpMOApi = (payload) => {
  // custom cookie setting
  document.cookie = "sendotp=true; path=/";
  const url = `${process.env.HOST_URL}/motororchestrator/api/v2/send-otp`;
  const { token, ...restPayload } = payload;
  // const url = `${process.env.SDUI_API_SERVICE}/send-otp`;
  // const url = "http://localhost:3001/sdui/api/v1/send-otp";
  // const url = "http://10.210.39.223:3000/sdui/api/v1/next-node"
  // const url = "https://auto-buy-sdui-service-uat.internal.ackodev.com/sdui/api/v1/next-node";
  // const apiPayload = {
  //   phone: restPayload?.phone,
  // };

  headers = {
    ...headers,
    "x-captcha-token": token
  };

  console.log({ headers });

  return new Promise((resolve, reject) => {
    axios
      .post(url, restPayload, { headers: headers, withCredentials: true })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const verifyOtpMoApi = (payload) => {
  const url = `${process.env.HOST_URL}/motororchestrator/api/v2/verify-otp`;
  // const url = `${process.env.SDUI_API_SERVICE}/send-otp`;
  // const url = "http://localhost:3001/sdui/api/v1/send-otp";
  // const url = "http://10.210.39.223:3000/sdui/api/v1/next-node"
  // const url = "https://auto-buy-sdui-service-uat.internal.ackodev.com/sdui/api/v1/next-node";

  return new Promise((resolve, reject) => {
    axios
      .post(url, payload, { withCredentials: true, headers: headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const consolelog = (log) => {
  return fetch("/api/falcon/log", {
    method: "POST",
    body: JSON.stringify({ log }),
    headers: {
      "Content-Type": "application/json"
    }
  });
};

// marking this as readinly api
const checkoutApi = async (proposalEkey) => {
  const url = `${process.env.SDUI_API_SERVICE}/checkout`;
  const bodyData = {
    data: {
      proposal_ekey: proposalEkey
    }
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bodyData)
    });

    if (!response.ok) {
      throw new Error(`Error in checkout API`);
    }

    const result = await response.json();
    console.log("Response:", result);
    return result;
  } catch (error) {
    console.error(error);
  }
};

const fetchChallan = async (payload) => {
  const { registration_number } = payload;

  try {
    const response = await fetch(
      `${process.env.HOST_URL}/vas/api/v1/challans/?registration-number=${registration_number}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          cookie: document.cookie
        }
      }
    );

    if (!response.ok) {
      throw new Error(`Error in challan API`);
    }
    const result = await response.json();

    return result;
  } catch (error) {
    console.log("^^^^^ result", { error });
    console.error(error);
  }
};

const fetchWinbackChallanCoupon = async (payload) => {
  const { registration_number, phone } = payload;

  const url = `${process.env.HOST_URL}/motororchestrator/api/v1/proposals/challan?registration_number=${registration_number}&phone=${phone}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Error in challan API`);
    }
    const result = await response.json();

    return result;
  } catch (error) {
    console.error(error);
  }
};

const getProposalJourneyVersion = async (proposalEkey: string) => {
  const url = `${process.env.HOST_URL}/motororchestrator/api/v1/proposals/journey_version/${proposalEkey}`;
  
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(document.cookie && { cookie: document.cookie })
      }
    });

    if (!response.ok) {
      throw new Error(`Error in journey version API`);
    }
    
    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error fetching journey version:", error);
    return { journey_version: "v3" };
  }
};

const getOrUpdateJourneyVersion = async (proposalEkey: string) => {
  const url = `${process.env.HOST_URL}/motororchestrator/api/v2/renewals/proposal/${proposalEkey}/journey-version`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(document.cookie && { cookie: document.cookie })
      }
    });

    if (!response.ok) {
      throw new Error(
        `Error in get or update journey version API `
      );
    }
    const result = await response.text();
    const journeyVersion = result.trim();
    return { journey_version: journeyVersion };
  } catch (error) {
    console.error(error);
  }
};

const getProposalDetails = async (proposalId: string) => {
  const url = `${process.env.HOST_URL}/motororchestrator/api/v2/proposals/${proposalId}`;

  const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(document.cookie && { cookie: document.cookie })
      }
    });

  if (!response.ok) {
    throw new Error(
      `Error fetching proposal details: ${response.status} ${response.statusText}`
    );
  }

  return response.json();
};

const checkUserLoginStatus = async () => {
  const url = `${process.env.HOST_URL}/api/user/details/`;
  
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        ...(document.cookie && { cookie: document.cookie })
      },
      credentials: "include"
    });

    const result = await response.json();
    
    if (result.ekey) {
      return { isLoggedIn: true, userData: result };
    } else if (result.success === false && result.error?.code === "NERERR_001") {
      return { isLoggedIn: false, error: result };
    } else {
      return { isLoggedIn: false, error: result };
    }
  } catch (error) {
    console.error("Error checking user login status:", error);
    return { isLoggedIn: false, error: error };
  }
};

export type OwnershipTransferApiItem = {
  phone: string;
  email: string | null;
  policyId: string;
  proposalId: string;
  url: string;
  status: string;
  message: string | null;
  ctaText: string | null;
  statusDescription: string | null;
  asset: {
    variantId: string;
    registrationNumber: string;
    vehicleName: string;
    vehicleType: string;
  };
  plan: {
    id: string;
    planName: string;
  };
};

const getOwnershipTransferList = (options?: {
  xSourceId?: string;
  params?: Record<string, string | number | boolean | undefined>;
}): Promise<OwnershipTransferApiItem[]> => {
  const url = `${process.env.HOST_URL}/policy-management/endorsement-orchestrator/api/v1/ownership-transfer`;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        withCredentials: true,
        params: options?.params,
        headers: {
          ...headers,
          Accept: "application/json, text/plain, */*",
          "x-source-id": options?.xSourceId ?? "STORE-FRONTEND"
        }
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export type MaverickPolicyRow = {
  id: string;
  ekey?: string;
  [key: string]: unknown;
};

export type GetPolicyByRegistrationResponse = {
  message?: string;
  data?: MaverickPolicyRow[];
};

const getMaverickPolicyByRegistrationNumber = (
  registrationNumber: string,
  options?: { xSourceId?: string }
): Promise<GetPolicyByRegistrationResponse> => {
  const defaultBase = `${process.env.HOST_URL}/policy-management/maverick/external/api/v2/policies`;
  const baseUrl = process.env.MAVERICK_GET_POLICY_URL || defaultBase;
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl, {
        withCredentials: true,
        params: { reg_no: registrationNumber },
        headers: {
          ...headers,
          Accept: "application/json, text/plain, */*",
          "X-SOURCE-ID":
            options?.xSourceId ||
            process.env.MAVERICK_X_SOURCE_ID ||
            "STORE-FRONTEND"
        }
      })
      .then((response) => {
        const body = response.data;
        if (Array.isArray(body)) {
          resolve({ data: body as MaverickPolicyRow[] });
          return;
        }
        resolve(body as GetPolicyByRegistrationResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const postOwnershipTransferCreate = (
  body: {
    policyId: string;
    phone: string;
    email: string | null;
    source: string;
  },
  options?: { xSourceId?: string }
): Promise<unknown> => {
  const url = `${process.env.HOST_URL}/policy-management/endorsement-orchestrator/api/v1/ownership-transfer/`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, body, {
        withCredentials: true,
        headers: {
          ...headers,
          "Content-Type": "application/json",
          Accept: "application/json, text/plain, */*",
          "x-source-id": options?.xSourceId ?? "STORE-FRONTEND"
        }
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export {
  fetchConfig,
  sendOTPApi,
  sendOtpMOApi,
  verifyOtpMoApi,
  checkoutApi,
  fetchChallan,
  fetchWinbackChallanCoupon,
  getProposalJourneyVersion,
  getOrUpdateJourneyVersion,
  getProposalDetails,
  checkUserLoginStatus,
  getOwnershipTransferList,
  getMaverickPolicyByRegistrationNumber,
  postOwnershipTransferCreate
};
